import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { isNullOrWhiteSpace } from 'ecs-react-components/dist/index.es';
import { messages } from './chemotherapy.i18n';
import { SecondaryDisplayItem } from './secondaryDisplayItem';

export class ChemotherapyDetail extends React.Component {
  configurationActive = (fieldName) => {
    if (this.props.capabilities.details.find((x) => x.fieldName === fieldName)) {
      return true;
    }
    return false;
  }

  render() {
    const agentName = isNullOrWhiteSpace(this.props.chemotherapy.agentNameDisplay) ?
      this.props.chemotherapy.agentName :
      this.props.chemotherapy.agentNameDisplay;
    const frequency = isNullOrWhiteSpace(this.props.chemotherapy.frequencyDisplay) ?
      this.props.chemotherapy.frequency :
      this.props.chemotherapy.frequencyDisplay;
    const trialIndicator = isNullOrWhiteSpace(this.props.chemotherapy.trialIndicatorDisplay) ?
      this.props.chemotherapy.trialIndicator :
      this.props.chemotherapy.trialIndicatorDisplay;
    const route = isNullOrWhiteSpace(this.props.chemotherapy.routeDisplay) ?
      this.props.chemotherapy.route :
      this.props.chemotherapy.routeDisplay;

    return (
      this.props.chemotherapy.isNullMessageHolder === false ?
      <div className="row item-row" data-qa={'chemotherapy_' + agentName}>
        <div className="col-md-4 primary-data">
          {
            this.props.chemotherapy.isPatientReviewed === false ?
              <span className="fa fa-circle"></span> : null
          }
          <span className="list-item">{agentName}</span>
        </div>
        <div className="col-md-8 secondary-data">
            <div className="inline-list">
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.trialName} />}
                value={this.props.chemotherapy.trialName} language={this.props.language}
                isActive={this.configurationActive('TrialName')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.startDate} />}
                value={this.props.chemotherapy.startDate} language={this.props.language} isDate
                isActive={this.configurationActive('StartDate')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.mostRecentTreatmentDate} />}
                value={this.props.chemotherapy.mostRecentTreatmentDate} language={this.props.language} isDate
                isActive={this.configurationActive('MostRecentTreatmentDate')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.endDate} />}
                value={this.props.chemotherapy.endDate} language={this.props.language} isDate
                isActive={this.configurationActive('EndDate')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.dose} />}
                value={this.props.chemotherapy.dose} language={this.props.language}
                isActive={this.configurationActive('Dose')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.cyclesDelivered} />}
                value={this.props.chemotherapy.cyclesDelivered} language={this.props.language}
                isActive={this.configurationActive('CyclesDelivered')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.frequency} />}
                value={frequency} language={this.props.language}
                isActive={this.configurationActive('Frequency')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerName} />}
                value={this.props.chemotherapy.providerName} language={this.props.language}
                isActive={this.configurationActive('ProviderName')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.institution} />}
                value={this.props.chemotherapy.institution} language={this.props.language}
                isActive={this.configurationActive('Institution')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerPhone} />}
                value={this.props.chemotherapy.providerPhone} language={this.props.language}
                isActive={this.configurationActive('ProviderPhone')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerEmail} />}
                value={this.props.chemotherapy.providerEmail} language={this.props.language}
                isActive={this.configurationActive('ProviderEmail')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.dosageForm} />}
                value={this.props.chemotherapy.dosageForm} language={this.props.language}
                isActive={this.configurationActive('DosageForm')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.drugCategory} />}
                value={this.props.chemotherapy.drugCategory} language={this.props.language}
                isActive={this.configurationActive('DrugCategory')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.route} />}
                value={route} language={this.props.language}
                isActive={this.configurationActive('Route')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.trialIndicator} />}
                value={trialIndicator} language={this.props.language}
                isActive={this.configurationActive('TrialIndicator')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.comment} />}
                value={this.props.chemotherapy.comment} language={this.props.language}
                isActive={this.configurationActive('Comment')}
              />
            </div>
        </div>
      </div>
        :
      <div className="row item-row" data-qa="chemotherapy_nullMessage">
        <div className="col-md-4 primary-data">
          {this.props.chemotherapy.nullMessage}
        </div>
      </div>
    );
  }
}

ChemotherapyDetail.propTypes = {
  chemotherapy: PropTypes.object.isRequired,
  language: PropTypes.string,
  capabilities: PropTypes.object.isRequired,
};
